import { TFIOSuggestion, EGender, EPartsLower } from '../../../types/fio';

export function getFilteredSuggest(suggest: TFIOSuggestion[], gender: EGender, currentPartFIO: EPartsLower) {
  return suggest
    .filter(item => (gender !== EGender.Unknown ? item.data.gender === gender : item))
    .filter(item => item.data[currentPartFIO as keyof typeof item.data]);
}
